@for (originalCode of originalCodes; track originalCode.code) {
  <div class="grid grid-cols-12 gap-4">
    <div class="col-span-4">
      <span class="font-semibold mr-1">Original {{ originalCode.orderType }} Code:</span>
      <span>{{ originalCode.code }}</span>
    </div>
    <div class="col-span-8">
      <span class="font-semibold mr-1">Original {{ originalCode.orderType }} Description:</span>
      <span>{{ originalCode.description }}</span>
    </div>
  </div>
}
